import { LegacyCardHeader } from "../../../../components/card/LegacyCard";
import { H2, H6 } from "@sellar-io/components";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import type {
  StockListResponseType,
  StorefrontAvailabilityGetResponseType,
} from "@sellar-io/api-v2/types";
import { CircularImage, Icon } from "../../../../components";
import { ProductCategoryAvailabilityBadge } from "../../Components/ProductCategoryAvailabilityBadge";
import { generateCategoryName } from "./CategoryListElementHeader.shared";

export default function CategoryListElementHeader({
  category,
  storefrontAvailability,
  onClick,
  editing = false,
}: {
  category: StockListResponseType[number];
  storefrontAvailability: StorefrontAvailabilityGetResponseType | null;
  onClick?: () => void;
  editing?: boolean;
}): ReactElement {
  return (
    <LegacyCardHeader
      className={twMerge(onClick && "hover:bg-zinc-50")}
      onClick={() => {
        onClick?.();
      }}
    >
      <div className="flex flex-col justify-start gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
        <div
          className={twMerge(
            "flex flex-col gap-4 rounded-t-lg md:flex-row md:justify-between",
            onClick && "cursor-pointer",
          )}
        >
          <div className="items-center gap-2 md:flex">
            {editing && <Icon icon={"MENU"} style={{ marginRight: 12 }} />}
            {category.imageUrl && (
              <>
                <CircularImage
                  src={category.imageUrl}
                  alt={"Category Image"}
                  size={50}
                />
              </>
            )}
            <div className="flex flex-col select-text">
              <H2>{category.name}</H2>
              <H6 className="text-gray-500">
                {generateCategoryName(category, true)}
              </H6>
            </div>
          </div>
        </div>

        {storefrontAvailability && (
          <ProductCategoryAvailabilityBadge
            storefrontAvailability={storefrontAvailability}
          />
        )}
      </div>
    </LegacyCardHeader>
  );
}
